var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgManageStudies = function SvgManageStudies(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "var(--sidebar-menu-item-color)",
    viewBox: "0 -960 960 960"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M360-600v-72h336v72zm0 120v-72h336v72zm144 312H216zm0 72H240q-40 0-68-28t-28-68v-144h96v-528h576v361q-20 1-38 7t-34 19v-315H312v456h289l-72 72H216v72q0 10.2 6.9 17.1T240-168h264zm72 0v-113l210-209q7.26-7.41 16.13-10.71Q811-432 819.76-432q9.55 0 18.31 3.5T854-418l44 45q6.59 7.26 10.29 16.13Q912-348 912-339.24t-3.29 17.92q-3.3 9.15-10.71 16.32L689-96zm288-243-45-45zM624-144h45l115-115-22-23-22-22-116 115zm138-138-22-22 44 45z"
  })));
};
export default SvgManageStudies;